import React, { FC, useEffect, useState } from 'react';
import { FormHelperText, TextField } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { LegacyEmployee } from 'src/interfaces/api/Employee';
import useAuth from 'src/hooks/api/useAuth';

interface Props {
  disabled?: boolean;
  className?: any;
  label?: string;
  employeeId?: LegacyEmployee['id'];
}

const LegacyEmployeeView: FC<Props> = React.forwardRef<any, Props>(
  ({ label, disabled, employeeId, className }, ref) => {
    const [employee, setEmployee] = useState<LegacyEmployee>();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();
    const { fetch } = useAuth();

    const fetchEmployee = (employeeId: number): Promise<LegacyEmployee> => {
      const queryURL = `/api/employee/show/{ employee(id: ${employeeId}){ id, firstname, lastname } }`;

      return fetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
        .then((resp) => resp.json())
        .then((data) => {
          if (data['data']['employee']) {
            return data['data']['employee'];
          }

          throw new Error('Aucun employé trouvé ...');
        });
    };

    useEffect(() => {
      if (employeeId) {
        fetchEmployee(employeeId)
          .then((employee) => {
            setEmployee(employee);
            setLoading(false);
          })
          .catch((e) => {
            setError(e.message);
            setLoading(false);
          });
      }
    }, [employeeId]);

    if (loading) {
      return <Skeleton height={50} />;
    }

    if (error) {
      return <div style={{ color: '#f44336' }}>{error}</div>;
    }

    return (
      <>
        <TextField
          className={className}
          ref={ref}
          variant='outlined'
          fullWidth
          value={`${employee?.firstname} ${employee?.lastname}`}
          label={label || 'Employé'}
        />

        {error && <FormHelperText>{error}</FormHelperText>}
      </>
    );
  }
);

export default React.memo(LegacyEmployeeView);
